import { Card, CardLocale, getCardTerms, getCardRedeemInstructions, getCardTitle, getCardFaq } from '@/src/types/card';
import { getCountryName } from '@/src/helpers/countries';
import { getTitleSuffix } from '@/constants';

export interface FAQItem {
    question: string;
    answer: string;
}

interface TranslationFunction {
    (key: string, values?: Record<string, any>): string;
    raw?: (key: string) => string;
}

const formatCountriesList = (countries: string[]): string => {
    if (countries.includes('WW') || countries.includes('ww')) {
        return 'Worldwide - can be used globally!';
    }

    const countryNames = countries.map(code => getCountryName(code.toUpperCase())).filter(Boolean);

    if (countryNames.length === 1) return `in ${countryNames[0]}`;
    if (countryNames.length === 2) return `in ${countryNames[0]} and ${countryNames[1]}`;

    const lastCountry = countryNames.pop();
    return `in ${countryNames.join(', ')} and ${lastCountry}`;
};

export function buildProductFaqItems(
    card: Card,
    locale: CardLocale,
    t: TranslationFunction
): FAQItem[] {
    // ACEB-206: template-generated FAQs hidden - only the card's own DB FAQ
    // entries (card.faq) remain. Redeem/terms keep their own accordions.
    // const cardTerms = getCardTerms(card, locale);
    // const cardRedeemInstructions = getCardRedeemInstructions(card, locale);
    // const cardTitle = getCardTitle(card, locale) + getTitleSuffix();

    // const dynamicFAQs: FAQItem[] = [
    //     {
    //         question: t('productFaq.validIn', { product: cardTitle }),
    //         answer: t('productFaq.validInAnswer', {
    //             product: cardTitle,
    //             countries: formatCountriesList(card.countries || [])
    //         })
    //     }
    // ];

    // const productFAQs: FAQItem[] = [
    //     {
    //         question: t('productFaq.howReceive'),
    //         answer: t('productFaq.howReceiveAnswer')
    //     },
    //     {
    //         question: t('productFaq.canUseMultiple'),
    //         answer: t('productFaq.canUseMultipleAnswer')
    //     },
    //     {
    //         question: t('productFaq.whatIfWrong'),
    //         answer: t('productFaq.whatIfWrongAnswer')
    //     },
    //     {
    //         question: t('productFaq.isSecure'),
    //         answer: t('productFaq.isSecureAnswer')
    //     },
    //     {
    //         question: t('productFaq.didNotReceive'),
    //         answer: t('productFaq.didNotReceiveAnswer')
    //     },
    //     {
    //         question: t('productFaq.cancelRefund'),
    //         answer: t('productFaq.cancelRefundAnswer')
    //     },
    //     {
    //         question: t('productFaq.codeNotWork'),
    //         answer: t('productFaq.codeNotWorkAnswer')
    //     },
    //     {
    //         question: t('productFaq.expiry'),
    //         answer: t('productFaq.expiryAnswer')
    //     }
    // ];

    // const conditionalFAQs: FAQItem[] = [];

    // if (cardRedeemInstructions) {
    //     conditionalFAQs.push({
    //         question: t('productFaq.howRedeem', { product: cardTitle }),
    //         answer: cardRedeemInstructions
    //     });
    // }

    // if (cardTerms) {
    //     conditionalFAQs.push({
    //         question: t('productFaq.termsQuestion'),
    //         answer: cardTerms
    //     });
    // }

    const cardFaqs: FAQItem[] = getCardFaq(card, locale).filter(f => f.question && f.answer) as FAQItem[];

    // return [...dynamicFAQs, ...productFAQs, ...conditionalFAQs, ...cardFaqs];
    return [...cardFaqs];
}
